import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { Dispatch, RootState } from '@/utils/store';

import Button from './Button';
import { SrOnly } from './Layout/Parts';

const StyledButton = styled(Button)<{ $active: boolean }>`
  position: relative;
  padding: 0;
  width: 32px;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.black : theme.colors.gray};
  > svg {
    margin: 0;
  }
`;

interface Props {
  className?: string;
}

const FullScreenButton: FC<Props> = ({ className }) => {
  const fullScreenModeEnabled = useSelector(
    (rootState: RootState) => rootState.layout.fullScreenModeEnabled,
  );

  const dispatch = useDispatch<Dispatch>();

  const onClick = () => dispatch.layout.toggleFullScreenMode();

  return (
    <StyledButton
      className={className}
      onClick={onClick}
      color="secondary"
      small
      $active={fullScreenModeEnabled}
    >
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {fullScreenModeEnabled ? (
          <>
            <path
              d="M8.5 3V14"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.96967 7.03033C3.67678 6.73744 3.67678 6.26256 3.96967 5.96967C4.26256 5.67678 4.73744 5.67678 5.03033 5.96967L7.03033 7.96967C7.10224 8.04158 7.15649 8.12445 7.19309 8.21291C7.22976 8.30134 7.25 8.39831 7.25 8.5C7.25 8.60169 7.22976 8.69866 7.19309 8.78709C7.15649 8.87555 7.10224 8.95842 7.03033 9.03033L7.03023 9.03043L5.03033 11.0303C4.73744 11.3232 4.26256 11.3232 3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96967L4.68934 9.25H1.5C1.08579 9.25 0.75 8.91421 0.75 8.5C0.75 8.08579 1.08579 7.75 1.5 7.75H4.68934L3.96967 7.03033Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9697 5.96967C12.2626 5.67678 12.7374 5.67678 13.0303 5.96967C13.3232 6.26256 13.3232 6.73744 13.0303 7.03033L12.3107 7.75H15.5C15.9142 7.75 16.25 8.08579 16.25 8.5C16.25 8.91421 15.9142 9.25 15.5 9.25H12.3107L13.0303 9.96967C13.3232 10.2626 13.3232 10.7374 13.0303 11.0303C12.7374 11.3232 12.2626 11.3232 11.9697 11.0303L9.96967 9.03033C9.89776 8.95842 9.84351 8.87555 9.80691 8.78709C9.77024 8.69866 9.75 8.60169 9.75 8.5C9.75 8.39831 9.77024 8.30134 9.80691 8.21291C9.84351 8.12445 9.89776 8.04158 9.96967 7.96967L11.9697 5.96967Z"
              fill="currentColor"
            />
          </>
        ) : (
          <>
            <path
              d="M8.5 3V14"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 8.5H1.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 10.5L1.5 8.5L3.5 6.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 8.5H15.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.5 6.5L15.5 8.5L13.5 10.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )}
      </svg>
      <SrOnly>Toggle full screen mode</SrOnly>
    </StyledButton>
  );
};

export default FullScreenButton;
